import { DatePickerInput } from "@mantine/dates";
import dayjs               from "dayjs"; // Make sure to import dayjs or your preferred date library
import "@mantine/dates/styles.css";

import useStyles from "_styles/pages/growthDashboard/datePicker";

// Your existing dayjs extensions
var isSameOrAfter   = require ( "dayjs/plugin/isSameOrAfter" );
var localizedFormat = require ( "dayjs/plugin/localizedFormat" );

dayjs.extend ( isSameOrAfter );
dayjs.extend ( localizedFormat );

const CustomDateRangePicker = ( {
	todaysDate,
	testDate,
	prodDate,
	label,
	customDate,
	setCustomDate,
	customMinDate,
	customMaxDate,
	isEndDatePicker
} ) => {
	function setMinDateForStartDatePicker () {
		const isProdDate = new Date ( dayjs ( testDate ).subtract ( 7, "month" ).isSameOrAfter ( prodDate ) );

		if ( isProdDate ) {
			if ( process.env.APP_ENV === "stage" )
				return new Date ( "10-1-2023" );

			return new Date ( dayjs ( testDate ).subtract ( 7, "month" ) );
		} else {
			return new Date ( dayjs ( prodDate ) );
		}
	}

	function setMaxForStartDatePicker () {
		return customMaxDate ? new Date ( dayjs ( customMaxDate ).subtract ( 1, "day" ) ) : new Date ( dayjs ( testDate ).subtract ( 1, "day" ) );
	}

	function setMaxForEndDatePicker () {
		return new Date ( dayjs ( testDate ) );
	}

	function setMinDateForEndDatePicker () {
		return customMinDate ? new Date ( dayjs ( customMinDate ).add ( 1, "day" ) ) : new Date ( dayjs ( testDate ) );
	}

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.dateRangePicker }>
			<DatePickerInput
				disableFuture = { todaysDate === testDate }
				label         = { label }
				maxDate       = { isEndDatePicker ? setMaxForEndDatePicker () : setMaxForStartDatePicker () }
				minDate       = { isEndDatePicker ? setMinDateForEndDatePicker () : setMinDateForStartDatePicker () }
				onChange      = { value => {
					setCustomDate ( dayjs ( value ).format ( "YYYY-MM-DD" ) );
				} }
				size          = "xl"
				styles        = { { input: { width: "20rem" } } }
				value         = { new Date ( customDate ) }
			/>
		</div>
	);
};

export default CustomDateRangePicker;
